import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { VehicleListScreen } from '../screens/vehicle/VehicleListScreen';
import { VehicleDetailsScreen } from '../screens/vehicle/VehicleDetailsScreen';
import { VehicleAssignmentScreen } from '../screens/assignment/VehicleAssignmentScreenNew';
import { AssignmentHistoryScreen } from '../screens/assignment/AssignmentHistoryScreen';
import AddVehicleScreen from '../screens/vehicle/AddVehicleScreen';
import { VehicleExportScreen } from '../screens/import-export/VehicleExportScreen';
import { Ionicons } from '@expo/vector-icons';
import { TouchableOpacity } from 'react-native';
import theme from '../theme';

const Stack = createStackNavigator();

export const VehicleNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false, // Disable all headers since we have custom header
      }}
    >
      <Stack.Screen 
        name="VehicleList" 
        component={VehicleListScreen} 
      />
      <Stack.Screen
        name="VehicleDetails"
        component={VehicleDetailsScreen}
      />
      <Stack.Screen
        name="VehicleAssignment"
        component={VehicleAssignmentScreen}
      />
      <Stack.Screen
        name="AssignmentHistory"
        component={AssignmentHistoryScreen}
      />
      <Stack.Screen
        name="AddVehicle"
        component={AddVehicleScreen}
      />
      <Stack.Screen
        name="VehicleExport"
        component={VehicleExportScreen}
      />
    </Stack.Navigator>
  );
};
